import { TranslateHelper } from '@app/_helpers';
import { Component, Input, OnInit } from '@angular/core';
import { Product } from '@interfaces/product';
import { RootService } from '@services/root.service';
import { TranslateModule } from '@ngx-translate/core';
import { RouterLink } from '@angular/router';
import { NgFor } from '@angular/common';

@Component({
    selector: 'app-widget-vendors',
    templateUrl: './widget-vendors.component.html',
    styleUrls: ['./widget-vendors.component.scss'],
    providers: [TranslateHelper],
    standalone: true,
    imports: [NgFor, RouterLink, TranslateModule]
})
export class WidgetVendorsComponent implements OnInit {
    @Input() header = '';
    @Input() vendors: any[] = [];

    constructor(public translateHlper : TranslateHelper) {

     }
    ngOnInit(): void {
        /* this.vendors.forEach((vendor)=>{
            vendor.images.url = this.imageUrl(vendor.images);
        }); */
    }

    imageUrl(imagesObject) {
        let image = 'assets/images/nologo.png';
        if (imagesObject) {
            let imageKey = Object.keys(imagesObject)[0]?.toString();
            let image = imagesObject?.[imageKey]?.thumb?.url || (imagesObject[imageKey]?.url || 'assets/images/nologo.png');
        }
        return image;
    }
}
